import React, { useState } from "react";
import { Text, View } from "react-native";
import { TouchableOpacity } from "react-native";
import { Modal } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { Clipboard } from "react-native";
import { toast } from "react-toastify";

const MessageOnClickModal = ({
  showPopup,
  handleClosePopup,
  popupPosition,
  messageContent,
  onDeletePress,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionPress = (option) => {
    setSelectedOption(option);

    if (option === "Copy") {
      Clipboard.setString(messageContent);
      toast.success("Message copied");
      handleClosePopup();
    } else if (option === "Delete") {
      onDeletePress();
      handleClosePopup();
    }
  };
  return (
    <Modal
      visible={showPopup}
      transparent={true}
      animationType="fade"
      onRequestClose={handleClosePopup}
    >
      <TouchableOpacity
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        activeOpacity={1}
        onPress={handleClosePopup}
      >
        <View
          style={[
            {
              position: "absolute",
              top: popupPosition.top,
              left: popupPosition.left,
              width: 126,
              backgroundColor: AppColors.grayColor_333333,
              borderWidth: 1,
              borderColor: AppColors.white,
            },
          ]}
        >
          <TouchableOpacity
            style={{
              paddingVertical: 10,
              backgroundColor:
                selectedOption === "React" ? "#595959" : "transparent",
              borderBottomColor: AppColors.white,
              borderBottomWidth: 1,
            }}
            onPress={() => handleOptionPress("React")}
          >
            <Text
              style={[AppFontStyle.BOLD_ANYBODY_12, { textAlign: "center" }]}
            >
              React
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={{
              paddingVertical: 10,
              backgroundColor:
                selectedOption === "Copy" ? "#595959" : "transparent",
              borderBottomColor: AppColors.white,
              borderBottomWidth: 1,
            }}
            onPress={() => handleOptionPress("Copy")}
          >
            <Text
              style={[AppFontStyle.BOLD_ANYBODY_12, { textAlign: "center" }]}
            >
              Copy
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={{
              paddingVertical: 10,
              backgroundColor:
                selectedOption === "Delete" ? "#595959" : "transparent",
            }}
            onPress={() => handleOptionPress("Delete")}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_12,
                { color: "red", textAlign: "center" },
              ]}
            >
              Delete
            </Text>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    </Modal>
  );
};

export default MessageOnClickModal;
